
import React from 'react';
import FooterLinks from './footer/FooterLinks';
import FooterBottom from './footer/FooterBottom';

const LandingFooter = () => {
  return (
    <footer className="bg-white border-t border-gray-100 py-12 text-gray-600">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <FooterLinks />
          <FooterBottom />
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
